<template>
  <v-layout row>
    <v-flex xs12 sm8 offset-sm2 lg4 offset-lg4>
      <v-card>
        <progress-bar :show="form.busy"></progress-bar>
        <form @submit.prevent="register" @keydown="form.onKeydown($event)" v-show="!success">
          <v-card-title primary-title>
            <h3 class="headline mb-0">{{ $t('register') }}</h3>
          </v-card-title>
          <v-card-text>

            <v-radio-group row v-model="form.is_company">
              <v-radio
                label="Private"
                value="0"
              ></v-radio>
              <v-radio
                label="Company"
                value="1"
              ></v-radio>
            </v-radio-group>

            <!-- Company name -->
            <text-input v-show="form.is_company==1"
              :form="form"
              :label="$t('name_company')"
              :v-errors="errors"
              :value.sync="form.company_name"
              browser-autocomplete="organization"
              name="company name"
              v-validate="form.is_company==1 ? 'required' :''"
            ></text-input>

            <!-- First Name -->
            <text-input v-show="form.is_company==0"
              :form="form"
              :label="$t('name_first')"
              :v-errors="errors"
              :value.sync="form.name_first"
              browser-autocomplete="given-name"
              name="first name"
              v-validate="form.is_company==0 ? 'required' :''"
            ></text-input>

            <!-- Last Name -->
            <text-input v-show="form.is_company==0"
              :form="form"
              :label="$t('name_last')"
              :v-errors="errors"
              :value.sync="form.name_last"
              browser-autocomplete="family-name"
              name="last name"
              v-validate="form.is_company==0 ? 'required' :''"
            ></text-input>

            <!-- Email -->
            <email-input
              :form="form"
              :label="$t('email')"
              :v-errors="errors"
              :value.sync="form.email"
              name="email"
              v-validate="'required|email'"
            ></email-input>

            <!-- Last Name -->
            <text-input
              :form="form"
              :label="$t('phone_number')"
              :v-errors="errors"
              :value.sync="form.phone"
              browser-autocomplete="tel"
              name="phone"
              v-validate="''"
            ></text-input>

            <v-alert
              :value="true"
              type="error"
              v-show="formError"
              transition="scale-transition"
              class="mb-3"
            >
              {{ formError }}
            </v-alert>

          </v-card-text>

          <v-card-actions>
            <submit-button :form="form" :label="$t('register')"></submit-button>
          </v-card-actions>
        </form>
        <div v-show="success">
          <v-card-text style="text-align:center;">
            <h1>Welcome!</h1>
            <p>You will soon recieve an email with a link to complete your account registration.</p>
          </v-card-text>
        </div>
      </v-card>
    </v-flex>
  </v-layout>

</template>

<script>
import Form from 'vform'

export default {
  name: 'register-view',
  metaInfo () {
    return { title: this.$t('register') }
  },

  data: () => ({
    form: new Form({
      name: '',
      email: '',
      is_company: '0',
      name_first: '',
      name_last: '',
      company_name: '',
    }),
    eye: true,
    success: false,
    formError: "",
  }),

  watch: {
    form : {
      handler: function (val, oldVal) { 
        this.clearerror()
      },
      deep: true
    }
  },

  methods: {
    async register () {
      if (await this.formHasErrors()) return
      this.busy = true

      // Register the user.
      const { data } = await this.form.post(process.env.API_URL+'/register')

      if(data.success){
        this.success = true
      } else if(data.error) {
        this.formError = data.error
      } else {
        this.formError = "Sorry, somthing went wrong. Please reload the page and try again."
      }

      this.busy = false
    },
    clearerror: function () {
      this.formError = ""
    }
  }
}
</script>



// WEBPACK FOOTER //
// register.vue?b7417b20